import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "@/i18n/translations";

const I18nContext = createContext(null);
const STORAGE_KEY = "roofborder_lang";

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = typeof window !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null;
    return saved === "fr" || saved === "en" || saved === "es" ? saved : "en";
  });

  const setLang = useCallback((l) => {
    setLangState(l);
    localStorage.setItem(STORAGE_KEY, l);
  }, []);

  // t("dash.title") with optional {n} interpolation
  const t = useCallback(
    (path, vars) => {
      const dict = translations[lang] || translations.en;
      let val = path.split(".").reduce((o, k) => (o ? o[k] : undefined), dict);
      if (val === undefined) {
        val = path.split(".").reduce((o, k) => (o ? o[k] : undefined), translations.en);
      }
      if (typeof val !== "string") return path;
      if (vars) Object.keys(vars).forEach((k) => { val = val.replace(`{${k}}`, vars[k]); });
      return val;
    },
    [lang]
  );

  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}
